import { combineReducers } from 'redux';
import { after_device_add_dialog_reducer, } from 'console/sim/after-device-add/reducer';
import { reducer as register_sim_dialog_reducer } from 'console/sim/register-sim-dialog/reducer';
const prolong_info_initial = {
    sim_id: null,
    months: null,
    loading: false,
    ok: false,
    error: null,
    amount_x100: null,
    until: null,
};
const prolong_info_reducer = (state = prolong_info_initial, action) => {
    switch (action.type) {
        case 'PROLONG_SIM_INFO__REQUEST':
            return {
                ...state,
                loading: true,
                ok: false,
                error: null,
                sim_id: action.sim_id,
            };
        case 'PROLONG_SIM_INFO__OK':
            return {
                ...state,
                loading: false,
                ok: true,
                error: null,
                sim_id: action.sim_id,
                months: action.months,
                amount_x100: action.amount_x100,
                until: action.until,
            };
        case 'PROLONG_SIM_INFO__FAIL':
            return {
                ...state,
                loading: false,
                ok: false,
                error: { error: action.error, error_ui: action.error_ui },
            };
        default:
            return state;
    }
};
const remove_initial = {
    loading: false,
    error: null,
};
const remove_reducer = (state = remove_initial, action) => {
    switch (action.type) {
        case 'REMOVE_SIM_REQUEST':
            return { ...state, loading: true, error: null };
        case 'REMOVE_SIM_REQUEST__OK':
            return { ...state, loading: false };
        case 'REMOVE_SIM_REQUEST__FAIL':
            return { ...state, loading: false, error: action.error };
        default:
            return state;
    }
};
export const reducer = combineReducers({
    prolong_info: prolong_info_reducer,
    remove_info: remove_reducer,
    after_device_add_dialog: after_device_add_dialog_reducer,
    register: register_sim_dialog_reducer,
});
